/**
 * YouTube Summary with ChatGPT & Claude — video/article summariser
 *
 * Declares ten WAR groups. Nine are scoped to specific AI/site origins (glasp.ai,
 * chatgpt.com, claude.ai, youtube.com, …) and their files are build-hashed. Only two
 * groups match every origin, and of those the sole stable, non-hashed path is
 * `src/utils/pdf/pdf.worker.min.mjs` — the bundled PDF.js worker, exposed with no
 * `use_dynamic_url`. Because the extension ID is in the URL, a successful fetch from any
 * page is conclusive for this extension.
 *
 * Manifest verified against version 2.1.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'nmmicjeknamkfloonkhhcjmomieiodli';

export const youtubeSummaryChatgptClaude: ExtensionDefinition = {
  id: ID,
  name: 'YouTube Summary with ChatGPT & Claude',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes:
    'Most WAR are origin-scoped and build-hashed; the one stable all-origins path is the ' +
    'PDF.js worker. A single fetch is conclusive.',
  signals: [
    {
      id: 'war-pdf-worker',
      kind: 'web-accessible-resource',
      description:
        'Fetch src/utils/pdf/pdf.worker.min.mjs — the only stable, non-hashed resource ' +
        'exposed to every origin with a fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'src/utils/pdf/pdf.worker.min.mjs'),
    },
  ],
};
